<app-navbar class="flex-none"></app-navbar>
<div class="flex-1 overflow-y-auto">
  <router-outlet></router-outlet>
</div>
